// src/components/MicrosoftSSOButton.jsx
import React from 'react';
import Button from '@mui/material/Button';
import { FaMicrosoft } from 'react-icons/fa';
import { styled } from '@mui/system';

// Define a styled Button using MUI's styled API
const StyledButton = styled(Button)(() => ({
  backgroundColor: '#ffffff',
  color: '#2074d4',
  textTransform: 'none',
  fontWeight: 'normal',
  padding: '4px 20px',
  marginTop: '20px',
  fontSize: '17px',
  border: '1px solid #d1d1d1',
  width: '100%',
  borderRadius: '4px',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#ffffff',
  },
}));

export const MicrosoftSSOButton = ({ onClick, disabled }) => (
  <StyledButton
    variant="contained"
    startIcon={<FaMicrosoft size={24} />}
    onClick={onClick}
    disabled={disabled}
    type="button"
  >
    <span>Sign in with Microsoft</span>
  </StyledButton>
);
